import React, { useCallback, useEffect, useRef } from "react";

const LatexRenderer = ({
  latex,
  displayMode = true,
  className = "",
  fitToContainer = false,
}) => {
  const containerRef = useRef(null);
  const Tag = displayMode ? "div" : "span";

  const fit = useCallback(() => {
    if (!fitToContainer) return;
    const container = containerRef.current;
    if (!container) return;

    const katexEl = container.querySelector(".katex");
    if (!katexEl) return;

    // Reset scale before measuring.
    katexEl.style.transform = "";
    katexEl.style.transformOrigin = "center center";

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const contentWidth = katexEl.scrollWidth;
    const contentHeight = katexEl.scrollHeight;

    if (!containerWidth || !contentWidth) return;

    const scaleW = containerWidth / contentWidth;
    const scaleH =
      containerHeight && contentHeight ? containerHeight / contentHeight : 1;
    const scale = Math.min(1, scaleW, scaleH);

    katexEl.style.transform = `scale(${scale})`;
  }, [fitToContainer]);

  useEffect(() => {
    if (containerRef.current && window.katex) {
      try {
        window.katex.render(latex, containerRef.current, {
          throwOnError: false,
          displayMode,
        });
      } catch (error) {
        console.error("Failed to render LaTeX:", error);
      }
    }
    requestAnimationFrame(() => fit());
  }, [latex, displayMode, fit]);

  useEffect(() => {
    if (!fitToContainer) return undefined;
    const container = containerRef.current;
    if (!container) return undefined;
    if (typeof ResizeObserver === "undefined") return undefined;

    const observer = new ResizeObserver(() => fit());
    observer.observe(container);
    return () => observer.disconnect();
  }, [fit, fitToContainer]);

  return <Tag ref={containerRef} className={className} />;
};

export default LatexRenderer;
